import React from 'react';
import { Control, FieldPath, FieldValues } from 'react-hook-form';
import Textarea, { TextareaProps } from './Textarea';
import { useFormField } from '../hooks/useFormField';

interface FormTextareaProps<T extends FieldValues> extends Omit<TextareaProps, 'name' | 'value' | 'onChange' | 'error'> {
  name: FieldPath<T>;
  control: Control<T>;
}

function FormTextarea<T extends FieldValues>({ 
  name, 
  control, 
  ...textareaProps 
}: FormTextareaProps<T>) {
  const { value, onChange, onBlur, error } = useFormField({ name, control });

  return (
    <Textarea
      {...textareaProps}
      name={name}
      value={value || ''}
      onChange={onChange}
      onBlur={onBlur}
      error={error}
    />
  );
}

export default FormTextarea;